<template>
  <div>
    <NavigationView />
    <div class="map-div" :class="{ open: slidingOpen }">
      <div v-once id="mapMonitorNew"></div>
      <div v-if="mapLoading">
        <LoadingSpinner/>
      </div>
      <div
        class="object-list_section"
        v-if="$store.state.user.roles.includes('ROLE_ADMIN')"
      >
        <div class="object-list_search">
          <div class="object-list_search-block">
            <input
              type="text"
              placeholder="Поиск"
              class="object-list_search-input"
              v-model="searchQuery"
            />
            <button
              @click="this.searchQuery = ''"
              v-if="searchQuery !== ''"
              class="object-list_search-close"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.707 6.70685L17.293 5.29285L12 10.5858L6.70697 5.29285L5.29297 6.70685L10.586 11.9998L5.29297 17.2928L6.70697 18.7068L12 13.4138L17.293 18.7068L18.707 17.2928L13.414 11.9998L18.707 6.70685Z"
                />
              </svg>
            </button>
          </div>
          <button class="sliding-btn" @click="slidingOpen = !slidingOpen">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.1893 6.70697L9.7753 5.29297L4.4823 10.586C4.10736 10.961 3.89673 11.4696 3.89673 12C3.89673 12.5303 4.10736 13.0389 4.4823 13.414L9.7753 18.707L11.1893 17.293L5.9003 12L11.1893 6.70697Z"
              />
              <path
                d="M18.1894 6.70697L16.7754 5.29297L10.7755 11.293C10.588 11.4805 10.4827 11.7348 10.4827 12C10.4827 12.2651 10.588 12.5194 10.7755 12.707L16.7754 18.707L18.1894 17.293L12.9004 12L18.1894 6.70697Z"
              />
            </svg>
          </button>
        </div>
        <nav v-if="$store.state.user.roles.includes('ROLE_ADMIN')">
          <ul class="nav nav-pills">
            <li :class="{ active: isActive }" @click="toggleActive(true)">
              <span style="font-size: 14px !important">Активные</span>
            </li>
            <li :class="{ active: isInactive }" @click="toggleActive(false)">
              <span style="font-size: 14px !important">Неактивные</span>
            </li>
          </ul>
        </nav>
        <div
          v-if="!startLoading"
          class="object-list_list"
          :class="{
            dispatcher: !$store.state.user.roles.includes('ROLE_ADMIN'),
          }"
          @scroll="onScroll"
        >
          <div
            class="object-list_item"
            v-for="item in filteredItems.slice(0, itemsLimit)"
            :key="item.id"
            :class="{ active: item.id === activeItem }"
            @click="showOnMap(item)"
          >
            <div class="object-list_item-title">
              <h4>{{ item.gosNumber }}</h4>
            </div>
            <div class="object-list_item-group-text">
              <div class="object-list_item-carrier object-list_item-text">
                Перевозчик: {{ item.carrierName }}
              </div>
              <div
                class="object-list_item-reg-num object-list_item-child-group-text"
              >
                <div class="object-list_item-reg-num object-list_item-text">
                  Марка/модель: <span>{{ item.model }}</span>
                </div>
                <div class="object-list_item-driver object-list_item-text">
                  Водитель: <span>{{ item.driver }}</span>
                </div>
              </div>
            </div>
            <div class="object-list_item-speed">
              <span
                class="object-list_item-speed-num"
                v-if="item.current_speed"
                >{{ item.current_speed }}</span
              >
              <span
                class="object-list_item-speed-num"
                v-if="!item.current_speed"
              >
                ---
              </span>
              <span class="object-list_item-speed-unit">км/ч</span>
            </div>
            <div class="object-list_item-last-message-time">
              {{ GetLastTime(item.lastUpdateTime) }}
            </div>
            <Popper hover placement="right">
              <template #content>
                <div
                  class="popup-popper monitoring"
                  :style="GetStatusColor(item.lastUpdateTime)"
                >
                  {{ GetStatusText(item.lastUpdateTime) }}
                </div>
              </template>
              <div
                class="object-list_item-online-status"
                :style="GetStatusColor(item.lastUpdateTime)"
              ></div>
            </Popper>
          </div>
        </div>
        <div v-else style="position: relative; height: 60px">
          <LoadingSpinner />
        </div>
        <div class="object-list_count">
          <p class="object-list_count-text">
            Найдено
            <span class="object-list_count-num">{{
              filteredItems.length
            }}</span>
            автомобилей
          </p>
        </div>
      </div>
      <div class="dashboard-overlay" :class="{ collapsed }" v-else>
        <MonitoringDispatcherView @collapsed-change="collapsed = $event" />
      </div>
      <MapControls
        v-if="showCustomControls"
        :trafficEnabled="trafficLayerEnabled"
        :isDarkTheme="isDarkTheme"
        :parkingEnabled="parkingEnabled"
        :mapProvider="currentMapProvider"
        @toggle-traffic="handleToggleTraffic"
        @toggle-parking="handleToggleParking"
        @change-map-theme="changeMapTheme"
        @change-map-provider="handleChangeMapProvider"
      />
      <div class="notifications-column">
        <PushNotification
          v-for="notification in notifications"
          :key="notification.id"
          :push="notification"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NavigationView from "@/components/NavigationView";
import store from "@/store";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import http from "@/http";
import LoadingSpinner from "@/components/LoadingSpinner";
import {
  formatTimeDifference,
  getColorBasedOnTimeDifference,
  getTextBasedOnTimeDifference,
} from "@/MainFunctions";
import { toast } from "vue3-toastify";
import MapControls from "./MapControls.vue";
import PushNotification from "@/components/Modals/PushNotification.vue";
import { usePushNotificationStore } from "@/store/pushNotificationStore";
import MonitoringDispatcherView from "./MonitoringDispatcherView.vue";
import "vue3-toastify/dist/index.css";
import { useMapStore } from "@/store/map.js";

export default {
  name: "MonitoringView",
  beforeMount() {
    if (store.state.user.roles.length === 0) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      startLoading: false,
      showCustomControls: false,
      trafficLayerEnabled: false,
      isActive: false,
      yandexJamsLayer: null,
      layersControlVisible: false,
      layersControl: null,
      customZoomControl: null,
      parkingEnabled: false,
      trafficLayer: null,
      mapControlButton: null,
      isInactive: false,
      isDarkTheme: false,
      currentMapProvider: "yandex",
      items: [],
      email: "",
      searchQuery: "",
      slidingOpen: false,
      itemsLimit: 20,
      activeItem: -1,
      collapsed: false
    };
  },
  components: {
    NavigationView,
    LoadingSpinner,
    MonitoringDispatcherView,
    MapControls,
    PushNotification,
  },
  mounted() {
    this.initMap();
    if (
      store.state.user.roles.length > 0 &&
      store.state.user.roles.includes("ROLE_ADMIN")
    ) {
      this.fetchObjects();
    }
  },
  computed: {
    filteredItems() {
      let filtered = this.items;

      // Фильтрация по статусу
      if (this.isActive) {
        filtered = filtered.filter((item) => item.status === "a");
      } else if (this.isInactive) {
        filtered = filtered.filter((item) => item.status === "ia");
      }

      // Фильтрация по строке поиска
      if (this.searchQuery) {
        filtered = filtered.filter((item) => {
          var gosNumber = `${item.gosNumber}`.toLowerCase();
          var imei = `${item.imei}`.toLowerCase();
          var carrierName = `${item.carrierName}`.toLowerCase();
          var searchQuery = this.searchQuery.toLowerCase();
          return (
            gosNumber.includes(searchQuery) ||
            imei.includes(searchQuery) ||
            carrierName.includes(searchQuery)
          );
        });
      }

      return filtered;
    },
    notifications() {
      const pushNotificationStore = usePushNotificationStore();
      return pushNotificationStore.notifications;
    },
    mapLoading() {
      const mapStore = useMapStore();
      return mapStore.loading;
    }
  },
  methods: {
    GetLastTime(ltm) {
      return formatTimeDifference(ltm);
    },
    addMapControlButton() {
      if (!store.map) return;

      // Создаем кастомный контрол для кнопки
      const MapControlButton = L.Control.extend({
        options: {
          position: "topright",
        },

        onAdd: () => {
          const container = L.DomUtil.create(
            "div",
            "leaflet-bar leaflet-control map-control-button"
          );
          const button = L.DomUtil.create(
            "a",
            "map-control-button-link",
            container
          );

          button.innerHTML = `
       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d="M20.5,3L20.34,3.03L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5A0.5,0.5 0 0,0 3.5,21L3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19.03 21,18.85 21,18.62V3.5A0.5,0.5 0 0,0 20.5,3M10,5.47L14,6.87V18.53L10,17.13V5.47M5,6.46L8,5.45V17.15L5,18.31V6.46M19,17.54L16,18.55V6.86L19,5.7V17.54Z" />
        </svg>
      `;
          button.href = "#";
          button.title = "Настройки карты";

          L.DomEvent.on(button, "click", (e) => {
            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);
            this.toggleCustomControls();
          });

          return container;
        },
      });

      // Добавляем кнопку на карту
      this.mapControlButton = new MapControlButton().addTo(store.map);
    },
    addCustomZoomControl() {
      if (!store.map) return;

      // Создаем кастомный контрол для зума
      const CustomZoomControl = L.Control.extend({
        options: {
          position: "topright",
        },

        onAdd: () => {
          const container = L.DomUtil.create(
            "div",
            "leaflet-bar leaflet-control custom-zoom-control"
          );

          // Кнопка увеличения
          const zoomInButton = L.DomUtil.create(
            "a",
            "custom-zoom-button zoom-in",
            container
          );
          zoomInButton.innerHTML = `
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>
        </svg>
      `;
          zoomInButton.href = "#";
          zoomInButton.title = "Увеличить";

          // Кнопка уменьшения
          const zoomOutButton = L.DomUtil.create(
            "a",
            "custom-zoom-button zoom-out",
            container
          );
          zoomOutButton.innerHTML = `
     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          <path d="M7 9v1h5V9H7z"/>
        </svg>
      `;
          zoomOutButton.href = "#";
          zoomOutButton.title = "Уменьшить";

          // Обработчики событий
          L.DomEvent.on(zoomInButton, "click", (e) => {
            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);
            if (store.map) {
              store.map.zoomIn();
            }
          });

          L.DomEvent.on(zoomOutButton, "click", (e) => {
            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);
            if (store.map) {
              store.map.zoomOut();
            }
          });

          return container;
        },
      });

      // Добавляем кастомный контрол на карту
      this.customZoomControl = new CustomZoomControl().addTo(store.map);
    },
    GetStatusColor(ltm) {
      return getColorBasedOnTimeDifference(ltm);
    },
    GetStatusText(ltm) {
      return getTextBasedOnTimeDifference(ltm);
    },
    updateMapTheme() {
      if (!store.map) return;

      // Удаляем старый слой Яндекс карты
      if (
        this.baseLayers &&
        this.baseLayers["Яндекс"] &&
        store.map.hasLayer(this.baseLayers["Яндекс"])
      ) {
        store.map.removeLayer(this.baseLayers["Яндекс"]);
      }

      if (
        this.baseLayers &&
        this.baseLayers["Google"] &&
        store.map.hasLayer(this.baseLayers["Google"])
      ) {
        store.map.removeLayer(this.baseLayers["Google"]);
      }

      const yandexMapType = this.isDarkTheme ? "map&theme=dark" : "map";
      const googleMapType = this.isDarkTheme ? "y" : "m"; // y = hybrid/dark, m = standard

      // Создаем новый слой Яндекс карты с учетом текущей темы
      const newYandexLayer = L.tileLayer(
        `https://core-renderer-tiles.maps.yandex.net/tiles?l=${yandexMapType}&x={x}&y={y}&z={z}&scale=2&lang=ru_RU`,
        {
          subdomains: ["01", "02", "03", "04"],
          attribution: '© <a http="yandex.ru" target="_blank">Яндекс</a>',
          reuseTiles: true,
          isElliptical: true,
          updateWhenIdle: false,
          minZoom: 3,
          maxZoom: 21,
        }
      );

      // Создаем новый слой Google карты с учетом текущей темы
      const newGoogleLayer = L.tileLayer(
        `https://www.google.cn/maps/vt?lyrs=${googleMapType}@189&gl=cn&x={x}&y={y}&z={z}`,
        {
          isElliptical: false,
          minZoom: 3,
          maxZoom: 21,
          attribution: "© <a href='https://google.com'>Google</a>",
        }
      );
      // Обновляем ссылку в baseLayers
      this.baseLayers["Яндекс"] = newYandexLayer;
      this.baseLayers["Google"] = newGoogleLayer;

      // Добавляем новый слой на карту только если Яндекс карта активна
      if (this.currentMapProvider === "yandex") {
        newYandexLayer.addTo(store.map);
      } else if (this.currentMapProvider === "google") {
        newGoogleLayer.addTo(store.map);
      }

      // Обновляем контрол слоев с новыми слоями
      if (this.layersControl) {
        store.map.removeControl(this.layersControl);
        this.layersControl = L.control.layers(
          this.baseLayers,
          this.overlayLayers,
          {
            position: "topright",
          }
        );
        this.layersControl.addTo(store.map);

        // Скрываем стандартный контрол слоев
        const controlElement = document.querySelector(
          ".leaflet-control-layers"
        );
        if (controlElement) {
          controlElement.classList.add("hidden-control");
        }
      }
    },
    changeMapTheme(isDark) {
      this.isDarkTheme = isDark;
      this.updateMapTheme();
    },
    toggleCustomControls() {
      this.showCustomControls = !this.showCustomControls;
    },
    toggleLayersControl() {
      this.layersControlVisible = !this.layersControlVisible;

      if (!store.map || !this.layersControl) return;

      const controlElement = document.querySelector(".leaflet-control-layers");
      if (controlElement) {
        if (this.layersControlVisible) {
          controlElement.classList.remove("hidden-control");
        } else {
          controlElement.classList.add("hidden-control");
        }
      }
    },
    handleToggleTraffic(enabled) {
      this.trafficLayerEnabled = enabled;

      if (!store.map) return;

      if (enabled && this.yandexJamsLayer) {
        this.yandexJamsLayer.addTo(store.map);
      } else if (
        !enabled &&
        this.yandexJamsLayer &&
        store.map.hasLayer(this.yandexJamsLayer)
      ) {
        store.map.removeLayer(this.yandexJamsLayer);
      }
    },
    async fetchObjects() {
      try {
        this.startLoading = true;
        const responses = await Promise.all([
          http.get("/api/car/get"),
          http.get("/api/carrier/get/short"),
        ]);
        if (responses[0].data !== null && responses[0].status === 200) {
          this.items = responses[0].data;
        }
        if (responses[1].data !== null && responses[1].status === 200) {
          this.multiselectItems = responses[1].data.carriers;
          this.items = this.items.map((item) => {
            item.carrierName = this.multiselectItems.find(
              (elem) => elem.value === item.carrierId
            ).label;
            return item;
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.startLoading = false;
      }
    },
    toggleActive(active) {
      if ((active && this.isActive) || (!active && this.isInactive)) {
        this.isActive = false;
        this.isInactive = false;
      } else {
        this.isActive = active;
        this.isInactive = !active;
      }
      this.itemsLimit = 20;
    },
    initMap() {
      // Инициализация карты Leaflet
      let google = new L.TileLayer(
        "https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}",
        {
          isElliptical: false,
          minZoom: 3,
          maxZoom: 21,
          attribution: "© <a href='https://google.com'>Google</a>",
        }
      );

      // слой Парковок Яндекса
      this.yandexParksLayer = L.tileLayer(
        "https://core-carparks-renderer-lots.maps.yandex.net/maps-rdr-carparks/tiles?l=carparks&z={z}&x={x}&y={y}&scale=1&lang=ru_RU",
        {
          attribution:
            '© <a href="https://yandex.ru" target="_blank">Яндекс</a>',
          minZoom: 3, // Увеличиваем минимальный зум, парковки видны только на больших масштабах
          maxZoom: 19,
        }
      );

      this.yandexJamsLayer = L.tileLayer(
        `https://core-jams-rdr-cache.maps.yandex.net/1.1/tiles?trf&l=trf,trfe&x={x}&y={y}&z={z}&scale=1`,
        {
          reuseTiles: true,
          updateWhenIdle: false,
          minZoom: 3,
          maxZoom: 19,
          maxNativeZoom: 19,
          tileSize: 256,
          zoomOffset: 0,
          noWrap: false,
          crs: L.CRS.EPSG3395,
        }
      );

      let yandex = L.tileLayer(
        "https://core-renderer-tiles.maps.yandex.net/tiles?l=map&x={x}&y={y}&z={z}&scale=2&lang=ru_RU",
        {
          subdomains: ["01", "02", "03", "04"],
          attribution: '© <a http="yandex.ru" target="_blank">Яндекс</a>',
          reuseTiles: true,
          isElliptical: true,
          updateWhenIdle: false,
          minZoom: 3,
          maxZoom: 21,
        }
      );

      let baseLayers = {
        Яндекс: yandex,
        Google: google,
      };
      let overlays = {
        Парковки: this.yandexParksLayer, // Используем this.yandexParksLayer
        Пробки: this.yandexJamsLayer,
      };

      let mapOptions = {
        center: [52.60311, 39.57076],
        zoom: 16,
        minZoom: 3,
        maxZoom: 21,
        maxNativeZoom: 21,
        zoomControl: false, // Отключаем стандартный контрол зума
        crs: L.CRS.EPSG3395,
      };

      // Сохраняем ссылки на слои для использования в MapControls
      this.baseLayers = baseLayers;
      this.overlayLayers = overlays;

      store.map = L.map("mapMonitorNew", mapOptions);

      // Создаем контрол слоев, но скрываем его
      this.layersControl = L.control.layers(baseLayers, overlays, {
        position: "topright",
      });
      this.layersControl.addTo(store.map);

      // Скрываем стандартный контрол слоев
      const controlElement = document.querySelector(".leaflet-control-layers");
      if (controlElement) {
        controlElement.classList.add("hidden-control");
      }

      // Добавляем Яндекс карту по умолчанию
      store.map.addLayer(yandex);

      // Добавляем кастомные контролы
      this.addCustomZoomControl();
      this.addMapControlButton();

      let center = store.map.getCenter();
      let zoom = store.map.getZoom();

      // Сохраняем настройки карты в localStorage
      if (
        localStorage.getItem("mapCenter") &&
        localStorage.getItem("mapZoom")
      ) {
        center = JSON.parse(localStorage.getItem("mapCenter"));
        zoom = JSON.parse(localStorage.getItem("mapZoom"));
        store.map.setView(center, zoom);
      }

      // Сохраняем позицию карты при изменении
      store.map.on("moveend", () => {
        localStorage.setItem(
          "mapCenter",
          JSON.stringify(store.map.getCenter())
        );
      });

      store.map.on("zoomend", () => {
        localStorage.setItem("mapZoom", JSON.stringify(store.map.getZoom()));
      });
    },

    // Добавляем новые методы для работы с MapControls
    handleToggleParking(enabled) {
      this.parkingEnabled = enabled;
      if (!store.map || !this.yandexParksLayer) return;

      if (enabled) {
        this.yandexParksLayer.addTo(store.map);
      } else if (store.map.hasLayer(this.yandexParksLayer)) {
        store.map.removeLayer(this.yandexParksLayer);
      }
    },

    handleChangeMapProvider(provider) {
      this.currentMapProvider = provider;

      if (!store.map || !this.baseLayers) return;

      // Удаляем все базовые слои
      Object.values(this.baseLayers).forEach((layer) => {
        if (store.map.hasLayer(layer)) {
          store.map.removeLayer(layer);
        }
      });

      // Удаляем все overlays
      Object.values(this.overlayLayers).forEach((layer) => {
        if (store.map.hasLayer(layer)) {
          store.map.removeLayer(layer);
        }
      });

      // Выключаем парковки и пробки
      this.handleToggleTraffic(false);
      this.handleToggleParking(false);

      // Добавляем выбранный слой
      if (provider === "yandex") {
        this.baseLayers["Яндекс"].addTo(store.map);
        store.map.options.crs = L.CRS.EPSG3395;
      } else if (provider === "google") {
        this.baseLayers["Google"].addTo(store.map);
        store.map.options.crs = L.CRS.EPSG3857;
      }

      // Перерисовываем слои после смены CRS
      useMapStore().allJsonLayers.forEach((layer) => {
        if (store.map.hasLayer(layer)) {
          store.map.removeLayer(layer);
          store.map.addLayer(layer);
        }
      })
    },
    showOnMap(item) {
      this.slidingOpen = false;

      if (store.currentMarker) {
        store.map.removeLayer(store.currentMarker);
        store.currentMarker = null;
      }

      if (item.latitude == null) {
        toast.error(`Нет данных телеметрии по автомобилю ${item.gosNumber}`, {
          autoClose: 2000,
        });
        this.activeItem = -1;
        return;
      }

      if (this.activeItem === item.id) {
        this.activeItem = -1;
      } else {
        this.activeItem = item.id;
        const latLng = [item.latitude, item.longitude];
        const htmlContent = `<div class="custom-marker">
                          <span class="marker-label">${item.gosNumber}</span>
                       </div>`;

        const customIcon = L.divIcon({
          className: "custom-marker-icon",
          html: htmlContent,
          iconAnchor: [0, 0],
        });

        store.currentMarker = L.marker(latLng, { icon: customIcon }).addTo(
          store.map
        );
        store.map.setView(latLng, store.map.getZoom());
      }
    },
    onScroll(e) {
      const { scrollTop, offsetHeight, scrollHeight } = e.target;
      if (
        scrollTop + offsetHeight + 50 >= scrollHeight &&
        this.filteredItems.length > this.itemsLimit
      ) {
        this.itemsLimit += 20;
      }
    },
  },
};
</script>

<style>
/* Стили Leaflet */
.leaflet-container .leaflet-marker-icon {
  /*background-image: url("~leaflet/dist/images/marker-icon.png");*/
  /*background-size: cover;*/
  /*border-radius: 50%;*/
}

.leaflet-container .leaflet-marker-shadow {
  /*background-image: url("~leaflet/dist/images/marker-shadow.png");*/
  background-size: cover;
}
.leaflet-touch .leaflet-control-layers-toggle {
  display: none;
}
.leaflet-control-attribution.leaflet-control {
  display: none;
}
.leaflet-control-zoom {
  display: none !important;
}

.map-div {
  position: relative;
  width: 100%;
  height: calc(100vh - 60px);
  height: calc(100dvh - 60px);
  overflow: hidden;
}

#mapMonitorNew {
  height: 100%;
  width: 100%;
  z-index: 0;
}

.dashboard-overlay {
  position: absolute;
  top: 19px;
  left: 12px;
  bottom: 12px;
  z-index: 1000;
  width: 430px;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
}

.dashboard-overlay.collapsed {
  width: 78px;
}

.object-list_section {
  width: 400px;
  position: absolute;
  top: 20px;
  left: 55px;
  z-index: 995;
  background: #fff;
  border-radius: 16px 16px 16px 16px;
  box-shadow: 0 5px 10px 0 rgba(221, 229, 237, 1);
}
.custom-zoom-control {
  border: none !important;
  border-radius: 8px !important;
  overflow: hidden !important;
}

.custom-zoom-button {
  display: flex !important;
  background: #fff !important;
  align-items: center !important;
  justify-content: center !important;
  width: 40px !important;
  height: 40px !important;
  color: #4d5460 !important;
  text-decoration: none !important;
  border: none !important;
  transition: background-color 0.2s ease !important;
}

.custom-zoom-button:hover {
  background: #f3f3f3 !important;
}

.custom-zoom-button:first-child {
  border-bottom: 1px solid #dde5ed !important;
}

.custom-zoom-button svg {
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.custom-zoom-button:hover svg {
  opacity: 1;
}

.object-list_search {
  display: flex;
  align-items: center;
  box-shadow: 0 5px 10px 0 rgba(221, 229, 237, 1);
}

.object-list_search-block {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
}

.object-list_search-close {
  position: absolute;
  background: transparent;
  border: 0;
  outline: none;
  top: 10px;
  right: 9px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.object-list_search-close svg {
  fill: #4d5460;
}

.object-list_search-input {
  background-image: url("../assets/images/fi-rs-search.svg");
  background-position: 13px center;
  background-repeat: no-repeat;
  padding: 0 45px;
  width: 100%;
  border: 0;
  outline: none;
  height: 43px;
  border-radius: 16px 16px 0 0;
}

.sliding-btn {
  display: none;
  border: 0;
  outline: none;
  background: transparent;
  cursor: pointer;
  width: 40px;
  height: 40px;
}

.sliding-btn svg {
  fill: #4d5460;
}

.nav-pills {
  margin-left: 10px;
}

.nav-pills > li {
  color: #4d5460;
  border: 1px solid #dde5ed;
  border-radius: 6px;
  margin: 16px 10px 0 0;
  padding: 0 7px 0 7px;
  cursor: pointer;
}
.notifications-column {
  position: absolute;
  top: 16px;
  right: 90px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 300px;
  z-index: 1;
  overflow: auto;
  max-height: calc(100vh - 90px);
}
.nav-pills > li.active {
  color: #fff;
  border: 1px solid #005291;
  background-color: #005291;
}

.object-list_list {
  margin-top: 16px;
  /*max-height: 70vh;*/
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  overflow-x: hidden;
}

.object-list_list.dispatcher {
  max-height: calc(100vh - 210px);
}

.object-list_item {
  position: relative;
  max-width: 100%;
  border: 1px solid #dde5ed;
  box-shadow: 0 4px 4px 0 rgba(221, 229, 237, 1);
  margin: 0 9px 14px 9px;
  padding: 10px 20px 10px 13px;
  border-radius: 13px;
  overflow: hidden;
  transition: all 0.4s;
}

.object-list_item:hover,
.object-list_item.active {
  border: 1px solid #418fde;
  background: rgba(65, 143, 222, 0.05);
  cursor: pointer;
}

.object-list_item-title {
  max-width: 90%;
}

.object-list_item-title h4 {
  font-family: OpenSansBold, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  text-align: left;
  color: #005291;
}

.object-list_item-text {
  font-family: OpenSansRegular, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.07px;
  text-align: left;
  max-width: 85%;
}

.object-list_item-text span {
  color: #8e8e8e;
}

.object-list_item-group-text {
  max-width: 100%;
}

.object-list_item-child-group-text {
  display: flex;
}

.object-list_item-child-group-text > div:not(:first-child) {
  margin-left: 20px;
}

.object-list_item-speed {
  position: absolute;
  top: 10px;
  right: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #005291;
}

.object-list_item-speed-num {
  font-family: OpenSansBold, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  background-color: #dde5ed;
  padding: 0 6px 0 6px;
  border-radius: 8px;
}

.object-list_item-speed-unit {
  font-family: OpenSansRegular, sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 19px;
  text-align: center;
}

.object-list_item-last-message-time {
  position: absolute;
  top: 5px;
  right: 0;
  transform: rotate(270deg);
  transform-origin: bottom right;
  font-family: OpenSansRegular, sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  text-align: right;
  color: #c1c6c8;
}

.object-list_item-online-status {
  position: absolute;
  top: -5px;
  right: -5px;
  height: 16px;
  width: 16px;
  background-color: #c1c6c8;
  border-radius: 100%;
}

.object-list_item-online-status-online {
  background-color: #418fde;
}

.object-list_count-text {
  font-family: OpenSansRegular, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  text-align: center;
  color: #4d5460;
  margin-top: 1rem;
}

.object-list_count-num {
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  text-align: center;
  color: #005291;
}

.custom-marker {
  white-space: nowrap;
  width: 100%;
}

.marker-label {
  font-family: OpenSansBold, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  text-align: left;
  color: #005291;
  position: relative;
  padding-left: 20px;
  padding-right: 5px;
  background-color: #fff;
  border-radius: 5px;
}

.marker-label::before {
  content: "";
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #005291;
  position: absolute;
  top: 2px;
  left: -5px;
}

.leaflet-bar.map-control-button {
  border-radius: 50% !important;
  margin-bottom: 10px !important;
  border: none !important;
  overflow: hidden !important;
}

.map-control-button-link {
  display: flex !important;
  background: #fff !important;
  align-items: center !important;
  justify-content: center !important;
  width: 65px !important;
  height: 65px !important;
  color: #4d5460 !important;
  text-decoration: none !important;
  border-radius: 50% !important;
}

.marker-label::after {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  top: 7px;
  left: 0;
}

/* for popper */
.object-list_item .inline-block {
  position: absolute;
  top: 2px;
  right: 0;
}

/* < 1200 */
@media screen and (max-width: 1199px) {
  #mapMonitorNew {
    height: unset;
    min-height: 40%;
    transition: all 0.4s;
  }

  .object-list_section {
    max-width: 100%;
    width: 100%;
    height: calc(60% + 15px);
    position: relative;
    left: 0;
    top: -15px;
    border-radius: 16px 16px 0 0;
    display: flex;
    flex-direction: column;
    transition: all 0.4s;
  }

  .object-list_list {
    max-height: 100%;
  }

  .object-list_list.dispatcher {
    max-height: 100%;
  }

  .sliding-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.4s;
    transform: rotate(90deg);
  }

  .map-div.open #mapMonitorNew {
    min-height: 0%;
  }

  .map-div.open .object-list_section {
    height: 100%;
    position: relative;
    left: 0;
    top: 0;
    border-radius: 0;
  }

  .map-div.open .object-list_search-input {
    border-radius: 0;
  }

  .map-div.open .sliding-btn {
    transform: rotate(-90deg);
  }
}
</style>
